import { apiInstance } from "v2/infrastructure/common/api/apiClient";
import Request from "v2/domain/benefitRequest/entities/Request";
import { CobeeResponse } from "v2/infrastructure/common/types/CobeeResponse";
import restoreBenefitRequests from "../../builders/restoreBenefitRequests";
import IFindBenefitRequestsResponseContent from "../../interfaces/IFindBenefitRequests";

export type FindBenefitRequestDetailResponse =
  CobeeResponse<IFindBenefitRequestsResponseContent>;

const getBenefitRequestDetail = async ({
  companyId,
  requestId,
}: {
  companyId: string;
  requestId: string;
}): Promise<Request> => {
  const { data } = await apiInstance.get<FindBenefitRequestDetailResponse>(
    `/v1/companies/${companyId}/benefit-requests/${requestId}`,
    {}
  );
  return restoreBenefitRequests(data.content);
};

export default getBenefitRequestDetail;
